const googleURL = {
  key: "AIzaSyD5DTZkV-2R7tuMVshT3dadzSA4v0Fx-fo",
  language: "en",
};

export default googleURL;
